import client from "../api-client";

const URL = `admin/team`;

export const get = async () => {
  return await client(URL);
};
